import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import ChangePassword from 'ChangePassword';
import SmsNotification from 'SmsNotification/SmsNotification';
import { profileType } from '_constants';

const ProfileButtons = ({
  hash,
  profile,
  permList,
  authUser,
  userData,
  sendingDDForm,
  onPrint,
  onMailSendOpen,
  onStatusOpen,
  onRemoveEmployee,
  onDdFormConfirmOpen,
  isArchivedEmployees = false,
}) => {
  return (
    <React.Fragment>
      <Link to={`/fire-history/${hash}`}>
        <button
          style={{ fontSize: '11px', padding: '6px 16px' }}
          className='button print'
        >
          Fire History
        </button>
      </Link>

      <Link to={`/fire-history/${hash}/legacy`}>
        <button
          style={{ fontSize: '11px', padding: '6px 16px' }}
          className='button print'
        >
          Legacy Fire History
        </button>
      </Link>

      {permList.includes('Manage Passwords') && (
        <ChangePassword
          userType='user'
          user={profile}
          isAdmin={authUser?.is_admin !== 0}
        />
      )}

      <button
        style={{ fontSize: '11px', padding: '6px 16px' }}
        className='button print'
        onClick={onPrint}
      >
        Print
      </button>

      {permList.includes('Message Employees') && (
        <button
          style={{ fontSize: '11px', padding: '6px 16px' }}
          className='button edit_resource'
          onClick={onMailSendOpen}
        >
          Message
        </button>
      )}

      {permList.includes('Status Update') && (
        <button
          style={{ fontSize: '11px', padding: '6px 16px' }}
          className='button edit_resource'
          onClick={onStatusOpen}
        >
          Edit Status 
        </button>
      )}

      {permList.includes('Remove Employee') && !isArchivedEmployees && (
        <button
          style={{ fontSize: '11px', padding: '6px 16px' }}
          className='button edit_resource'
          onClick={onRemoveEmployee}
        >
          Remove Employee
        </button>
      )}

      {(permList.includes('Modify SMS Notification Preference') ||
        authUser?.id === userData?.id) &&
        userData && (
          <SmsNotification
            initialStatus={userData.sms_notify}
            providerOptedOutStatus={userData.sms_provider_opt_out}
            type={profileType.EMPLOYEE}
            id={userData.id}
            customClass={'edit_resource xs-font'}
          />
        )}

      {permList.includes('Send DD Form') && (
        <button
          className='button edit_resource'
          onClick={onDdFormConfirmOpen}
          disabled={sendingDDForm}
          style={{ fontSize: '11px', padding: '6px 16px' }}
        >
          Send DD Form
        </button>
      )}
    </React.Fragment>
  );
};

ProfileButtons.propTypes = {
  hash: PropTypes.string,
  profile: PropTypes.object,
  permList: PropTypes.array,
  authUser: PropTypes.object,
  userData: PropTypes.object,
  sendingDDForm: PropTypes.bool,
  onPrint: PropTypes.func.isRequired,
  onMailSendOpen: PropTypes.func.isRequired,
  onStatusOpen: PropTypes.func.isRequired,
  onRemoveEmployee: PropTypes.func.isRequired,
  onDdFormConfirmOpen: PropTypes.func.isRequired,
};

export default ProfileButtons;
